import { native } from '@forest/native-services'
import { shouldMockAPI } from './params'

export type L10nParam = {
  type: 'integer' | 'float' | 'string'
  value: string
}

const cache = new Map<string, Promise<string | null>>()

const MOCK_MESSAGES: Record<string, string> = {
  tree_type_1_title: 'Cherry Blossom',
  tree_type_79_title: 'Sakura',
  tree_type_106_title: 'Monstera',
  special_event_title: 'Back-to-School Challenge',
  special_event_content:
    'Invite friends to plant together for [%1$d] minutes and unlock the [%2$s] for your best summer yet!',
}

// Native does the positional substitution in production; the mock path mimics
// it for the placeholder forms the catalog actually uses.
function applyMockParams(template: string, params: L10nParam[] = []) {
  return params.reduce((text, param, i) => {
    const mark = param.type === 'string' ? 's' : 'd'
    return text
      .replace(`[%${i + 1}$${mark}]`, param.value)
      .replace(`[%${mark}]`, param.value)
  }, template)
}

export function getLocalizedMessage(
  key: string,
  params?: L10nParam[],
): Promise<string | null> {
  if (!key) return Promise.resolve(null)
  if (import.meta.env.DEV && shouldMockAPI && MOCK_MESSAGES[key]) {
    return Promise.resolve(applyMockParams(MOCK_MESSAGES[key], params))
  }
  const cacheKey = params?.length ? key + JSON.stringify(params) : key
  const cached = cache.get(cacheKey)
  if (cached) return cached
  const promise = native.l10n
    .getLocalizedString({ key, params })
    .then((value) => (value === key ? null : value))
    .catch((err) => {
      cache.delete(cacheKey)
      throw err
    })
  cache.set(cacheKey, promise)
  return promise
}
